import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: nilsfast
 * id 9373446C-95C3-4160-9CBC-FF1DEF5C9F28
 * name label-multiple
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/label-multiple.svg
 * tags
 */
export const LabelMultipleIcon = createSvgIcon(<><path d="M4 19H13L11 21H4C3.5 21 2.97 20.79 2.59 20.41C2.21 20.03 2 19.5 2 19V9H4V19M17.63 5.84C17.27 5.33 16.67 5 16 5H8C6.9 5 6 5.9 6 7V15C6 16.1 6.9 17 8 17H16C16.67 17 17.27 16.66 17.63 16.15L22 11L17.63 5.84Z" /></>, 'LabelMultipleIcon');
export default LabelMultipleIcon